import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";
import { classesURL } from "../../Hooks/URL";
import useFetchWhen from "../../Hooks/useFetchWhen";
import AddClass from "../../Templates/Classes/AddClass/AddClass";

function AddClassPage({ Edit = false }) {
  const { contextData } = useContext(userContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const [classData, setClassData] = useState(null);

  const { data, loading, error } = useFetchWhen(`${classesURL}/${id}`, Edit);

  useEffect(() => {
    if (!loading && !error && data) {
      setClassData(data?.data);
    }
  }, [data, loading, error]);

  return (
    <AddClass
      role={contextData?.role}
      Edit={Edit}
      Class={classData}
      loading={loading}
      navigate={navigate}
    />
  );
}

export default AddClassPage;
